import React from 'react';
import icon from '../../../../../../assets/icons/charts/zoomAndFilter/icon_facet_river.svg';
import SVG from "react-inlinesvg";

const IconFacetRiverChart = () => (

    <SVG src={icon}  height={40} style = {{ marginTop: 10}} />

);
export default IconFacetRiverChart;